<div class="flex flex-col gap-6">
	<section class="flex items-center justify-between gap-4">
		<div class="flex items-center gap-4">
			<h3 class="h3">Integration Status</h3>
			<ui-status [status]="STATUSES.CONNECTED"></ui-status>
		</div>
		<div class="flex gap-4 items-center">
			<ui-button
				label="Disconnect"
				icon="plug-off"
				color="error"
				preset="MEDIUM_EMPHASIS"
				(click)="disconnectUser()"
			/>
		</div>
	</section>

	<ui-section
		title="Update Signature"
		subtitle="Clear the existing signature and draw a new one below to adjust the digital
    signature added to applicable mortgage forms."
	>
		<div section-content class="flex flex-col">
			<app-signature-pad
				card-content
				[(signatureImg)]="signature"
				[showSaveButton]="true"
				(saveClick)="saveSignature()"
			></app-signature-pad>
		</div>
	</ui-section>

	<ui-section
		title="Security PIN"
		subtitle="Enter and confirm a new 4 digit PIN below to be required before the transmission
    of applicable mortgage forms to lenders."
	>
		<div section-content class="space-y-4">
			<ui-section type="sub-section" title="Current PIN">
				<div section-content class="flex gap-4">
					<div
						class="h-9 p-2 rounded-md border flex w-full items-center duration-300"
						(click)="revealPin && copyPin()"
						[ngClass]="{
							'cursor-pointer hover:bg-gray-200': revealPin,
						}"
					>
						<ng-container *ngIf="!revealPin; else showPin">
							<span class="flex items-center flex-grow">
								<i-tabler name="point-filled" class="w-3 h-3" />
								<i-tabler name="point-filled" class="w-3 h-3" />
								<i-tabler name="point-filled" class="w-3 h-3" />
								<i-tabler name="point-filled" class="w-3 h-3" />
							</span>
						</ng-container>
						<ng-template #showPin>
							<span class="flex items-center flex-grow">
								{{ pin }}
							</span>
							<div class="flex gap-1 items-center">
								<i-tabler name="copy" class="w-4 h-4 text-gray-500" />
								<span class="p-sm">Copy</span>
							</div>
						</ng-template>
					</div>
					<ui-button
						[icon]="revealPin ? 'eye-off' : 'eye'"
						color="gray"
						[style]="'outline'"
						(click)="revealPinToggle()"
					/>
				</div>
			</ui-section>
			<ui-section type="sub-section" title="Update PIN">
				<form
					#newPinForm="ngForm"
					section-content
					[formGroup]="form"
					(ngSubmit)="savePin()"
					class="flex flex-col gap-4"
				>
					<div
						class="flex flex-col gap-4"
						[ngClass]="{
							'opacity-40 pointer-events-none': pinSaving,
						}"
					>
						<app-input
							[exactLength]="4"
							required
							[submitted]="newPinForm.submitted"
							name="pin"
							formControlName="accessPin"
							appDigitsOnly
							type="password"
							label="New PIN"
						></app-input>
						<app-input
							[exactLength]="4"
							required
							[submitted]="newPinForm.submitted"
							name="confirmPin"
							formControlName="confirmAccessPin"
							type="password"
							label="Confirm New PIN"
							appDigitsOnly
						></app-input>
					</div>
					<ui-button
						type="submit"
						[loading]="pinSaving"
						class="self-end"
						label="Update PIN"
						preset="MEDIUM_EMPHASIS"
						[disabled]="form.invalid || pinSaving"
					></ui-button>
				</form>
			</ui-section>
		</div>
	</ui-section>
</div>
